import { render, staticRenderFns } from "./Lenta.vue?vue&type=template&id=5edae376&"
import script from "./Lenta.vue?vue&type=script&lang=js&"
export * from "./Lenta.vue?vue&type=script&lang=js&"
import style0 from "./Lenta.vue?vue&type=style&index=0&id=5edae376&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports